import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ThemeProvider,
  Typography,
} from '@mui/material';
import {} from 'mui-datatables';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

import PaymentRow from './PaymentRow';
import { serviceLinePaymentTableTheme } from '../../../../../../utils/theme';
import { FORTA_BLUE } from '../../../../../../utils/colors';
import { usePayorResponsibilityContext } from './PayorResponsibilityTable';

import type { IClaimPayment, IClaimPolicy } from '../../../../../../utils/types';

interface IServiceLinePaymentTableProps {
  isEditable: boolean;
  claimId: number;
  serviceLineId: number;
  policies: IClaimPolicy[];
  isAllowableStored: boolean;
  payments: IClaimPayment[];
}

function ServiceLinePaymentsTable({
  isEditable,
  claimId,
  serviceLineId,
  payments,
  policies,
  isAllowableStored,
}: IServiceLinePaymentTableProps) {
  const { itemBeingModified, handleAddNewPayment } = usePayorResponsibilityContext();

  return (
    <Box sx={{ pl: 6, pt: 3, pb: 1 }}>
      <ThemeProvider theme={serviceLinePaymentTableTheme}>
        <Table sx={{ mb: 2 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderTopLeftRadius: '8px' }}></TableCell>
              <TableCell>Payor</TableCell>
              <TableCell>Allowable</TableCell>
              <TableCell>Adjust</TableCell>
              <TableCell>Deduct.</TableCell>
              <TableCell>Co-ins.</TableCell>
              <TableCell>Co-pay</TableCell>
              <TableCell>Payment</TableCell>
              <TableCell>Received</TableCell>
              <TableCell>Cleared</TableCell>
              <TableCell sx={{ minWidth: 150 }}>Paid to subscriber</TableCell>
              <TableCell>Type</TableCell>
              <TableCell sx={{ borderTopRightRadius: '8px' }}>Transaction ID </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ mt: -2 }}>
            {payments.map((payment, index) => (
              <PaymentRow
                key={payment.id ?? index}
                isEditable={isEditable}
                claimId={claimId}
                serviceLineId={serviceLineId}
                payment={payment}
                policies={policies}
                isAllowableStored={isAllowableStored}
                isFirstRow={index === 0}
                isLastRow={index === payments.length - 1}
                rowIndex={index}
              />
            ))}
          </TableBody>
        </Table>
      </ThemeProvider>
      {isEditable && (
        <Box sx={{ display: 'flex', mt: -1 }}>
          <IconButton
            sx={{
              borderRadius: '8px',
              color: FORTA_BLUE.primary,
            }}
            disabled={Boolean(itemBeingModified)}
            onClick={() => {
              handleAddNewPayment(serviceLineId);
            }}
          >
            <AddOutlinedIcon sx={{ width: 21, height: 21, mr: 0.5 }} data-testid="addServiceRow" />
            <Typography>Add</Typography>
          </IconButton>
        </Box>
      )}
    </Box>
  );
}
export default ServiceLinePaymentsTable;
